import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import * as rg4js from 'raygun4js';
import { environment } from 'src/environments/environment';

@Injectable()
export class SettingsProvider {
  private config: any;

  public loadConfig(http): Promise<any> {
    console.log('loading config');
    return this.getJSON(http)
      .pipe(
        tap((env) => {
          this.config = env;

          (<any>window).Stripe.setPublishableKey(this.stripePublishableKey);

          if (environment.production) {
            rg4js('apiKey', this.config.raygunClientApiKey);
            rg4js('setVersion', this.config.version);
            rg4js('enableCrashReporting', false);
            rg4js('enablePulse', true);
            rg4js('options', {
              debugMode: !environment.production,
            });
          }

          if (!environment.production) {
            rg4js('disableAutoBreadcrumbsConsole');
          }
        })
      )
      .toPromise();
  }

  public getJSON(http): Observable<any> {
    return http.get('/api/settings/client');
  }

  public get configuration(): any {
    return this.config;
  }

  public get clientIP(): string {
    return this.config.clientIP;
  }

  public get backendUrl(): string {
    return this.config.backendUrl;
  }

  public get applicationName(): string {
    return this.config.applicationName;
  }

  public get siteUrl(): string {
    return this.config.siteUrl;
  }

  public get office365ClientId(): string {
    return this.config.office365ClientId;
  }

  public get stripePublishableKey(): string {
    return this.config.stripePublishableKey;
  }

  public get stripeClientKey(): string {
    return this.config.stripeClientKey;
  }

  public get linkedInClientKey(): string {
    return this.config.linkedInClientKey;
  }

  public get authTokenName(): string {
    if (this.applicationName === 'StreamifyATL') {
      return 'streamifyatl-currentUser';
    } else {
      return 'StockTrader-currentUser';
    }
  }
}
